/**
 * Admin-assigned user segment tags (mirrors dream-be lib/userTypes.ts).
 * New users are 'standard_user'; admins re-tag from Platform Stats.
 */
export type UserType =
  | 'standard_user'
  | 'dream_employee'
  | 'ugc_creator'
  | 'linkedin_influencer'
  | 'twitter_influencer';

/** Funnel bucket for sign-ups with no referrer on record. */
export const NO_REFERRER = 'no_referrer';

export type ReferrerType = UserType | typeof NO_REFERRER;

export interface UserTypeOption<T extends string = UserType> {
  value: T;
  label: string;
}

export const USER_TYPE_OPTIONS: UserTypeOption[] = [
  { value: 'standard_user', label: 'Standard User' },
  { value: 'dream_employee', label: 'Dream Employee' },
  { value: 'ugc_creator', label: 'UGC Creator' },
  { value: 'linkedin_influencer', label: 'LinkedIn Influencer' },
  { value: 'twitter_influencer', label: 'Twitter Influencer' },
];

export const REFERRER_TYPE_OPTIONS: UserTypeOption<ReferrerType>[] = [
  ...USER_TYPE_OPTIONS,
  { value: NO_REFERRER, label: 'No referrer' },
];

const LABELS: Record<string, string> = Object.fromEntries(
  REFERRER_TYPE_OPTIONS.map((o) => [o.value, o.label]),
);

export const userTypeLabel = (value: string): string => LABELS[value] ?? value;
